import { ComponentType } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyReportTooltipModalDocuments } from 'common/module/property-report/tooltip-modal/documents/element';
import { PropertyReportTooltipModalEmail } from 'common/module/property-report/tooltip-modal/email/element';
import { PropertyReportTooltipModalModalContentType } from 'common/module/property-report/tooltip-modal/modal-content.type';

type TooltipModalItem = {
  title: string;
  content: ComponentType;
};

type TooltipModalInformationContent = {
  [key in PropertyReportTooltipModalModalContentType]: TooltipModalItem;
};

export const tooltipModalInformationContent: TooltipModalInformationContent = {
  documents: {
    title: i18nTranslate('ReportProperty_UploadFollowingDocuments'),
    content: PropertyReportTooltipModalDocuments,
  },
  email: {
    title: i18nTranslate('ReportProperty_ProvideEmailHint'),
    content: PropertyReportTooltipModalEmail,
  },
  default: {
    title: 'Default Title',
    content: null,
  },
};
